import timeTrackingModel from '$$timeTrackingModel';

export default function (instance, ganttData) {
  instance.ganttDataApi.getTimeLogsByParams = (ganttId, taskId, logId) => {
    if (!ganttData) {
      return timeTrackingModel.getLogsByParamsNotCopy(ganttId, taskId, logId);
    }

    return timeTrackingModel._getLogsByParams(ganttData.timeTrackingData, taskId, logId);
  };
}
